module.exports = __webpack_public_path__ + "img/logo-ojo.872fffd0.svg";